import { store } from "@betacrew/jars-flux";
import { PAGE_STATE } from "../../constants/constants";

export const componentKey = "APP_LOADER";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        updatePageLoadingState: (state, action) => {
            state.pageLoadingState = action.payload;
        }
    },
    initialReducerState: {
        pageLoadingState: PAGE_STATE.PRE_LOADING,
    },
})

export const {
    updatePageLoadingState,
} = actions;